import { HttpInterceptorFn } from '@angular/common/http';

export const debugInterceptor: HttpInterceptorFn = (req, next) => {
  //console.groupCollapsed(`HTTP Request: ${req.method} ${req.url}`);
  //console.log('Headers:');
  req.headers.keys().forEach(() => {
    //console.log(`  ${key}:`, req.headers.getAll(key));
  });
  //console.log('withCredentials:', req.withCredentials);
  //console.log('Body:', req.body);
  //console.groupEnd();

  return next(req);
};
